import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
} from "@clerk/clerk-react";
import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div
      className="min-h-screen bg-cover bg-center relative"
      style={{
        backgroundImage: "url('/hero.jpg')",
      }}
    >
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-32">
        <div className="max-w-xl text-white">
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">
            Simple, private accounting.
          </h1>

          <p className="mt-6 text-lg text-gray-200">
            Securely connect your bank and view your transactions
            in one clean dashboard.
          </p>

          <div className="mt-8 flex gap-4">
            <SignedOut>
              <SignInButton>
                <button className="px-6 py-3 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700">
                  Sign In
                </button>
              </SignInButton>

              <SignUpButton>
                <button className="px-6 py-3 rounded-md bg-white text-gray-900 font-medium hover:bg-gray-100">
                  Get Started
                </button>
              </SignUpButton>
            </SignedOut>

            <SignedIn>
              <Link
                to="/"
                className="px-6 py-3 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700"
              >
                Go to Dashboard
              </Link>
            </SignedIn>
          </div>
        </div>
      </div>
    </div>
  );
}